// OrderTrackingLive.jsx — Carte de suivi VIVANTE dans le chat (Phase 3)
// ─────────────────────────────────────────────────────────────────────────────
// Poll le payload rx.v1 order_tracking (contrat figé, validé serveur) toutes les
// meta.refresh_hint_s secondes ; CESSE le polling aux états terminaux (règle 5
// du contrat). Re-validation Zod côté client (défense en profondeur).
// ─────────────────────────────────────────────────────────────────────────────

import React, { useEffect, useRef, useState } from 'react';
import OrderTrackingTemplate from '@/rx-engine/templates/order_tracking';
import { OrderTrackingSchema } from '@rx-schemas';

const API = process.env.REACT_APP_BACKEND_URL || '';
const TERMINAL = ['completed', 'delivered', 'dispatch_expired', 'disputed', 'cancelled'];

export default function OrderTrackingLive({ orderId, userId }) {
  const [payload, setPayload] = useState(null);
  const timerRef = useRef(null);
  const stoppedRef = useRef(false);

  useEffect(() => {
    stoppedRef.current = false;

    const poll = async () => {
      if (stoppedRef.current) return;
      try {
        const r = await fetch(`${API}/api/v3/dispatch/orders/${orderId}/rx-tracking?user_id=${encodeURIComponent(userId || '')}`);
        const d = await r.json().catch(() => ({}));
        if (d.ok && d.payload) {
          const parsed = OrderTrackingSchema.safeParse(d.payload);
          if (parsed.success) {
            setPayload(parsed.data);
            const state = parsed.data.sections.find((s) => s.type === 'tracking_status')?.state;
            if (TERMINAL.includes(state) || d.terminal) {
              stoppedRef.current = true; // règle 5 du contrat : état terminal → stop polling
              return;
            }
          }
        }
      } catch (_) { /* réseau — on garde le dernier état affiché */ }
      const hint = (payload && payload.meta && payload.meta.refresh_hint_s) || 10;
      timerRef.current = setTimeout(poll, hint * 1000);
    };
    poll();

    return () => {
      stoppedRef.current = true;
      if (timerRef.current) clearTimeout(timerRef.current);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderId, userId]);

  if (!payload) return null;

  const handleAction = (actionId) => {
    if (actionId === 'refresh_tracking') {
      stoppedRef.current = true;
      if (timerRef.current) clearTimeout(timerRef.current);
      stoppedRef.current = false;
      // relance immédiate
      (async () => {
        try {
          const r = await fetch(`${API}/api/v3/dispatch/orders/${orderId}/rx-tracking?user_id=${encodeURIComponent(userId || '')}`);
          const d = await r.json().catch(() => ({}));
          if (d.ok && d.payload) {
            const parsed = OrderTrackingSchema.safeParse(d.payload);
            if (parsed.success) setPayload(parsed.data);
          }
        } catch (_) { /* noop */ }
      })();
    }
    if (actionId === 'contact_support') {
      window.open('https://wa.me/?text=' + encodeURIComponent(`Bonjour AYA, j'ai un souci avec ma commande ${orderId}`), '_blank');
    }
  };

  return <OrderTrackingTemplate payload={payload} onAction={handleAction} />;
}
